import { createRelayResource, RelayResourceConfig } from '@townsquare/relay-utils';
import type {
	ResourceStoreContext,
	RouterContext,
	RouterDataContext,
} from '@townsquare/router/routing-types';
import type { HomeResourceContext } from '@townsquare/router/types';
import { fg } from '@townsquare/stat-sig/gate';

import TeamDirectoryViewQuery, {
	type TeamDirectoryViewQuery as TeamDirectoryViewQueryType,
} from '../components/__generated__/TeamDirectoryViewQuery.graphql';

import { appendEmptyTeamSearchToTql } from './utils';

export const getTeamDirectoryResourceQuery = (
	_routerContext: RouterContext | RouterDataContext,
	resourceContext: ResourceStoreContext,
): RelayResourceConfig<TeamDirectoryViewQueryType> => {
	const context = resourceContext as HomeResourceContext;
	const teamQuery = appendEmptyTeamSearchToTql('');

	return {
		query: TeamDirectoryViewQuery,
		variables: {
			organisationId: context.workspace?.organisationId ?? context.orgId ?? '',
			cloudId: (context.collabContext?.rovoWorkspace || context.workspace?.cloudId) ?? 'None',
			teamQuery,
			skipOldCheck: fg('fix-people-teams-directory-existence-check'),
		},
	};
};

export const teamDirectoryResource = createRelayResource<TeamDirectoryViewQueryType>({
	getQuery: getTeamDirectoryResourceQuery,
});
